module.exports = __webpack_public_path__ + "static/media/register.e228c75f.png";